import { render, staticRenderFns } from "./moduleLoader.vue?vue&type=template&id=444b0d37&"
import script from "./moduleLoader.vue?vue&type=script&lang=js&"
export * from "./moduleLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports